import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

const INITIAL_VALUE = {
  name: '',
  email: '',
  password: '',
  provider: '',
  imapHost: '',
  imapPort: '',
  sendingEnabled: false,
  smtpHost: '',
  smtpPort: ''
};

const EmailBoxRegistrationModal = ({
  showModal,
  handleClose,
  handleSubmit
}) => {
  const [validated, setValidated] = useState(false);
  const [body, setBody] = useState(INITIAL_VALUE);
  const form = useRef(null);

  useEffect(() => {
    if (showModal) {
      clearFields();
      setValidated(false);
    }
  }, [showModal]);

  const onSubmit = e => {
    if (form.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      handleSubmit({
        name: body.name.trim(),
        email: body.email.trim(),
        password: body.password ? body.password.trim() : null,
        provider: body.provider.trim(),
        imapHost: body.imapHost.trim(),
        imapPort: Number(body.imapPort),
        sendingEnabled: body.sendingEnabled,
        smtpHost: body.smtpHost ? body.smtpHost.trim() : null,
        smtpPort: body.smtpPort ? Number(body.smtpPort) : null
      });
      clearFields();
      setValidated(false);
    }
  };

  const handleChangeProvider = e => {
    switch (e.target.value) {
      case 'OFFICE_365':
        setBody(prevBody => ({
          ...prevBody,
          provider: e.target.value,
          imapHost: 'outlook.office365.com',
          imapPort: '993',
          password: null,
          sendingEnabled: false,
          smtpHost: '',
          smtpPort: ''
        }));
        break;
      case 'GOOGLE':
        setBody(prevBody => ({
          ...prevBody,
          provider: e.target.value,
          imapHost: 'imap.gmail.com',
          imapPort: '993',
          password: null,
          sendingEnabled: false,
          smtpHost: '',
          smtpPort: ''
        }));
        break;
      default:
        setBody(prevBody => ({
          ...prevBody,
          provider: e.target.value,
          imapHost: '',
          imapPort: '',
          sendingEnabled: false,
          smtpHost: '',
          smtpPort: ''
        }));
    }
  };

  const clearFields = () => {
    setBody(INITIAL_VALUE);
  };

  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Nova caixa de email</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form validated={validated} ref={form}>
          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="emailbox.name">
              <Form.Label>
                Nome <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Nome"
                value={body.name}
                onChange={e =>
                  setBody(prevBody => ({ ...prevBody, name: e.target.value }))
                }
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira um nome.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="emailbox.provider">
              <Form.Label>
                Provedor <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                aria-label="Provedor"
                className="flex-1 me-2"
                onChange={handleChangeProvider}
                required
              >
                <option value="">Selecione uma opção</option>
                <option value="OFFICE_365">Office 365</option>
                <option value="GOOGLE">Google</option>
                <option value="OTHERS">Outros</option>
              </Form.Select>
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira um provedor.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="emailbox.email">
              <Form.Label>
                E-mail <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="email"
                placeholder="E-mail"
                value={body.email}
                onChange={e =>
                  setBody(prevBody => ({ ...prevBody, email: e.target.value }))
                }
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira um e-mail.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="emailbox.password">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                required={body.provider == 'OTHERS'}
                disabled={body.provider != 'OTHERS' && body.provider != ''}
                type="password"
                placeholder="Senha"
                value={body.password}
                onChange={e =>
                  setBody(prevBody => ({
                    ...prevBody,
                    password: e.target.value
                  }))
                }
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira uma senha.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="10" controlId="emailbox.imapHost">
              <Form.Label>
                IMAP Host <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="IMAP Host"
                value={body.imapHost}
                onChange={e =>
                  setBody(prevBody => ({
                    ...prevBody,
                    imapHost: e.target.value
                  }))
                }
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira o endereço IMAP.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="2" controlId="emailbox.imapPort">
              <Form.Label>
                Porta IMAP <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Porta"
                value={body.imapPort}
                onChange={e =>
                  setBody(prevBody => ({
                    ...prevBody,
                    imapPort: e.target.value
                  }))
                }
              />
              <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Insira uma porta.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="emailbox.sendingEnabled">
              <Form.Check
                type="checkbox"
                label="Habilitar envio de e-mails"
                checked={body.sendingEnabled}
                onChange={e =>
                  setBody(prevBody => ({
                    ...prevBody,
                    sendingEnabled: e.target.checked
                  }))
                }
              />
            </Form.Group>
          </Row>

          {body.sendingEnabled && (
            <Row className="mb-3">
              <Form.Group as={Col} md="10" controlId="emailbox.smtpHost">
                <Form.Label>SMTP Host</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="SMTP Host"
                  value={body.smtpHost}
                  onChange={e =>
                    setBody(prevBody => ({
                      ...prevBody,
                      smtpHost: e.target.value
                    }))
                  }
                />
              </Form.Group>

              <Form.Group as={Col} md="2" controlId="emailbox.smtpPort">
                <Form.Label>Porta SMTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Porta"
                  value={body.smtpPort}
                  onChange={e =>
                    setBody(prevBody => ({
                      ...prevBody,
                      smtpPort: e.target.value
                    }))
                  }
                />
              </Form.Group>
            </Row>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Fechar
        </Button>
        <Button variant="primary" type="submit" onClick={onSubmit}>
          <FontAwesomeIcon icon={faSave} className="me-2" />
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EmailBoxRegistrationModal;
